export default {
  start: 'start',
  dest: 'dest',
  poi: 'poi',
};
